import React from "react";
import PensilIcon from "../icons/BusinessHub/PensilIcon";
import TrashIcon from "../icons/BusinessHub/TrashIcon";
import { MdDragIndicator } from "react-icons/md";

function SubcategoryRow({
  subcategory,
  isSelected,
  isDragging,
  isDragOver,
  onSelect,
  onDragStart,
  onDragOver,
  onDragEnter,
  onDrop,
  onDragEnd,
  onToggleVisibility,
  onEdit,
  onDelete,
}) {
  return (
    <div
      className={`category-settings-row ${
        isSelected ? "category-settings-row-selected" : ""
      } ${isDragging ? "category-settings-row-dragging" : ""} ${
        isDragOver ? "category-settings-row-drag-over" : ""
      }`}
      draggable
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragEnter={onDragEnter}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      onClick={onSelect}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect();
        }
      }}
    >
      <div
        className="category-settings-drag-handle"
        aria-label={`Reorder ${subcategory.subCategoryName}`}
        title="Drag to reorder"
      >
        <MdDragIndicator />
      </div>
      <div className="category-settings-row-main">
        <div className="category-settings-row-name">
          {subcategory.subCategoryName}
        </div>
        <div className="category-settings-row-meta">
          <span>{subcategory.visible ? "Displayed" : "Hidden"}</span>
        </div>
        {subcategory.description ? (
          <div className="category-settings-row-description">
            {subcategory.description}
          </div>
        ) : null}
      </div>

      <label
        className="category-settings-checkbox-label"
        onClick={(e) => e.stopPropagation()}
      >
        <input
          type="checkbox"
          checked={subcategory.visible}
          onChange={onToggleVisibility}
        />
        <span>Display to Users</span>
      </label>

      <div className="category-settings-row-actions">
        <button
          className="category-settings-icon-btn"
          aria-label={`Edit ${subcategory.subCategoryName}`}
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
        >
          <PensilIcon />
        </button>
        <button
          className="category-settings-icon-btn category-settings-delete-btn"
          aria-label={`Delete ${subcategory.subCategoryName}`}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <TrashIcon fill="#d92d20" />
        </button>
      </div>
    </div>
  );
}

export default SubcategoryRow;
